export const Footer = () => {
    return (
              <div id="footer" className="footer fw-bold text-light py-5">
        <div className="container">
          <div className="row g-4">

            {/* Columna 1 */}
            <div className="col-12 col-md-6 col-lg-3">
              <h2 className="fw-bolder">Rocky</h2>
              <p>Sistema de información en atención primaria S.A.S</p>

              <div className="d-flex gap-3 mt-3 ">
                <a
                  href="https://wa.me/573112378357"
                  className="fs-4 text-light text-decoration-none color-text-footer"
                >
                  <i className="fa-brands fa-whatsapp"></i>
                </a>

                <a
                  href="https://www.instagram.com/rockysas2023/"
                  className="fs-4 text-light text-decoration-none color-text-footer"
                >
                  <i className="fa-brands fa-instagram"></i>
                </a>
              </div>
            </div>

            {/* Columna 2 */}
            <div className="col-12 col-md-6 col-lg-3">
              <h2 className="fw-bolder">Servicios</h2>
              <ul className="list-unstyled mt-3 h-color-ul-footer">
                <li>Sistemas de información en salud</li>
                <li>Auditoría integral en salud</li>
                <li>Informes para entes de control (EPS)</li>
                <li>Preauditoría y radicación de cuentas médicas</li>
                <li>Auditoría, cartera y contratación</li>
                <li>Suministro de equipos de cómputo</li>
                <li>Soporte técnico</li>
                <li>Rocky Learn</li>
                <li>Redes y mantenimiento</li>
              </ul>
            </div>

            {/* Columna 3 */}
            <div className="col-12 col-md-6 col-lg-3">
              <h2 className="fw-bolder">Sedes</h2>
              <p className="mt-3">
                <strong>Carrera 8 N° 54A - 04<br />Prados del Norte</strong>
              </p>
              <p>
                <strong>Tunja - Boyacá</strong>
              </p>
            </div>

            {/* Columna 4 */}
            <div className="col-12 col-md-6 col-lg-3 color-text-footer">
              <h2 className="fw-bolder">Contáctanos</h2>
              <p className="mt-3">Tu opinión es importante...</p>
              <p>
                <i className="fa fa-phone me-2"></i>
                (+57) 311 237 8357
              </p>
              <p>
                <i className="fa fa-envelope me-2"></i>
                sistemarocky@hotmail.com
              </p>
            </div>

          </div>

          {/* Footer inferior */}
          <hr className="my-4" />
          <div className="text-center small">
            © {new Date().getFullYear()} Rocky S.A.S – Todos los derechos reservados
          </div>
        </div>
      </div>
    )
}